import { GRAY_800, GRAY_900 } from 'constants/styling/theme'
import { Stack, Typography } from '@mui/material'

import { BorderBoxWrapper } from 'components/common/BorderBoxWrapper'
import { MUIButton } from 'components/common/MUIButton'
import React from 'react'
import { useTranslation } from 'react-i18next'

/**
 * @component User Cookies settings displayed in Profile page
 * @example
 * <CookiesSetting />
 */
export const CookiesSetting: React.FC = () => {
  const { t } = useTranslation(['profile'])

  return (
    <Stack gap="1.6rem">
      <Typography variant="text-xl" fontWeight={600} color={GRAY_900}>
        {t('cookies.title')}
      </Typography>

      <BorderBoxWrapper padding={2.4} gap={1.6} display="inline-grid">
        <Stack alignItems="center" flexDirection="row" justifyContent="space-between">

          <Typography variant="text-sm" fontWeight={400} color={GRAY_800}>
            {t('cookies.description')}
          </Typography>

          {/* @ts-ignore */}
          <MUIButton onClick={() => Cookiebot.renew()}>
            {t('cookies.reset_button')}
          </MUIButton>

        </Stack>
      </BorderBoxWrapper>
    </Stack>
  )
}
